import { AlertBannerError, SpacerVertical } from '@klarna/bubble-ui';
import { TrackImpression } from 'mage-insights';
import React from 'react';
import { useErrorController } from '../controllers/ErrorController';
import { useMidController } from '../controllers/MidController';
import { usePluginController } from '../controllers/PluginController';
export default function ErrorBanner() {
    const { errorMessage, errorId } = useErrorController();
    const { pluginId } = usePluginController();
    const { selectedMid } = useMidController();
    const event = {
        category: `boost-home/plugin-guide/${pluginId}/error/${errorId}`,
        action: 'impression',
        label: selectedMid !== null && selectedMid !== void 0 ? selectedMid : undefined
    };
    return (React.createElement(React.Fragment, null, errorMessage &&
        React.createElement(React.Fragment, null,
            React.createElement(TrackImpression, { event: event },
                React.createElement(AlertBannerError, { content: errorMessage })),
            React.createElement(SpacerVertical, { spaceToken: 'space.500' }))));
}
